import { useEffect, useState } from "react";
import { getActiveOverrideTenantName } from "../config/tenants";

/**
 * ATT-3226: staging-only indicator that a QA tenant override is active.
 *
 * Renders a small, non-blocking banner naming the simulated tenant
 * ("Simulating tenant: <districtName>") so a viewer cannot mistake simulated
 * branding for the real tenant. Gated entirely behind
 * `NEXT_PUBLIC_ALLOW_TENANT_OVERRIDE === "true"` via
 * `getActiveOverrideTenantName()`, so it NEVER renders in production.
 *
 * Client-only (mounted guard) to avoid an SSR/CSR hydration mismatch: the
 * override target is read from the browser query/cookie, which the server does
 * not see during page SSR.
 */
export default function TenantOverrideBanner() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  const tenantName = getActiveOverrideTenantName();
  if (!tenantName) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="tenant-override-banner"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2147483647,
        pointerEvents: "none",
        textAlign: "center",
        padding: "4px 12px",
        fontSize: 12,
        fontWeight: 600,
        color: "#1a1a1a",
        background: "#ffd54f",
        borderTop: "1px solid #d4a900",
      }}
    >
      {`Simulating tenant: ${tenantName}`}
    </div>
  );
}
